<template>
  <div class="d-flex align-items-center">
    <div class="side-frame-danger group-title">
      {{ '评审意见' }}
    </div>
    <div>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-primary"
        @click="$emit('openDetailDialog', { type: 'add' })"
        :disabled="disabled"
      >
        {{ '添加评审意见' }}
      </b-button>
      <!-- <b-button
        class="mr-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openDetailDialog', { type: 'addFinal' })"
        :disabled="disabled"
        v-if="allow('F')"
      >
        {{ $l('form_btn_final') || '添加终审意见' }}
      </b-button> -->
    </div>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
}
export default {
  props: { disabled: { type: Boolean, default: false } },
  data() {
    return {
      form: { ...initForm },
    }
  },
  activated() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>
<style lang="scss" scoped></style>
